import { render, staticRenderFns } from "./classifyAdd.vue?vue&type=template&id=d767bfc4&scoped=true&"
import script from "./classifyAdd.vue?vue&type=script&lang=js&"
export * from "./classifyAdd.vue?vue&type=script&lang=js&"
import style0 from "./classifyAdd.vue?vue&type=style&index=0&id=d767bfc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d767bfc4",
  null
  
)

export default component.exports